/* SKY product image viewer.
   Opens at FIT (contain, scale 1) on the tapped image. The customer zooms:
   pinch, or double-tap toggling fit <-> 2.5x centred on the tap point.
   Gesture conflict rule: scale === 1 -> horizontal swipe navigates,
   vertical swipe-down closes; scale > 1 -> any drag PANS (navigation and
   close are only reachable at fit). Pan is clamped so at least the full
   viewport of image stays reachable. Zoom resets on every image change.
   One surface: white, matching the product photography. */
(() => {
  if (window.skyViewerInit) return; window.skyViewerInit = true;

  const media = () => document.querySelector('.product-information__media');
  let urls = [], idx = 0, scale = 1, tx = 0, ty = 0, savedY = 0;
  let overlay, stage, img, thumbs, counter;

  const bigSrc = (im) => {
    const s = im.currentSrc || im.src;
    return s.replace(/(\?[^#]*?)width=\d+/, '$1width=1600');
  };

  const clamp = () => {
    const vw = stage.clientWidth, vh = stage.clientHeight;
    const r = img.getBoundingClientRect();
    const w = (r.width / scale) * scale, h = (r.height / scale) * scale; // displayed at scale
    const baseW = img.clientWidth, baseH = img.clientHeight;
    const mx = Math.max(0, (baseW * scale - vw) / 2), my = Math.max(0, (baseH * scale - vh) / 2);
    tx = Math.min(mx, Math.max(-mx, tx)); ty = Math.min(my, Math.max(-my, ty));
  };
  const apply = () => { clamp(); img.style.transform = `translate(${tx}px, ${ty}px) scale(${scale})`; };

  const setIndex = (i, keepZoom) => {
    idx = (i + urls.length) % urls.length;
    scale = 1; tx = 0; ty = 0;                       /* zoom resets on image change */
    img.src = urls[idx];
    apply();
    counter.textContent = (idx + 1) + ' / ' + urls.length;
    [...thumbs.children].forEach((t, j) => t.classList.toggle('is-on', j === idx));
    const on = thumbs.children[idx];
    if (on) on.scrollIntoView({ inline: 'nearest', block: 'nearest' });
  };

  const open = (startIdx) => {
    const m = media(); if (!m) return;
    const imgs = [...m.querySelectorAll('slideshow-slide img')];
    if (!imgs.length) return;
    urls = imgs.map(bigSrc);
    if (!overlay) build();
    savedY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${savedY}px`;
    document.body.style.width = '100%';
    overlay.style.display = 'flex';
    document.body.classList.add('sky-viewer-open');
    setIndex(startIdx || 0);
  };
  const close = () => {
    overlay.style.display = 'none';
    document.body.classList.remove('sky-viewer-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, savedY);                       /* scroll restored */
  };

  const build = () => {
    overlay = document.createElement('div'); overlay.className = 'sky-viewer'; overlay.setAttribute('role','dialog'); overlay.setAttribute('aria-label','Product images');
    overlay.innerHTML = '<button class="sky-viewer__x" aria-label="Close">&times;</button>'
      + '<div class="sky-viewer__stage"><img alt="" draggable="false"></div>'
      + '<div class="sky-viewer__bar"><span class="sky-viewer__count"></span><div class="sky-viewer__thumbs"></div></div>';
    document.body.appendChild(overlay);
    stage = overlay.querySelector('.sky-viewer__stage');
    img = stage.querySelector('img');
    thumbs = overlay.querySelector('.sky-viewer__thumbs');
    counter = overlay.querySelector('.sky-viewer__count');
    overlay.querySelector('.sky-viewer__x').addEventListener('click', close);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && overlay.style.display !== 'none') close(); });

    const m = media();
    [...m.querySelectorAll('slideshow-slide img')].forEach((si, j) => {
      const t = document.createElement('img');
      t.src = (si.currentSrc || si.src); t.alt = ''; t.loading = 'lazy';
      t.addEventListener('click', () => setIndex(j));  /* jump straight, at fit */
      thumbs.appendChild(t);
    });

    /* gestures */
    const pts = new Map(); let startDist = 0, startScale = 1, startTx = 0, startTy = 0;
    let sx = 0, sy = 0, moved = false, lastTap = 0, lastTapX = 0, lastTapY = 0;
    const mid = () => { const a = [...pts.values()]; return { x: (a[0].x + a[1].x) / 2, y: (a[0].y + a[1].y) / 2 }; };
    const dist = () => { const a = [...pts.values()]; return Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y); };
    stage.addEventListener('pointerdown', (e) => {
      try { stage.setPointerCapture(e.pointerId); } catch (_) { /* released/synthetic pointer */ }
      pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (pts.size === 1) { sx = e.clientX; sy = e.clientY; startTx = tx; startTy = ty; moved = false; }
      if (pts.size === 2) { startDist = dist(); startScale = scale; startTx = tx; startTy = ty; }
    });
    stage.addEventListener('pointermove', (e) => {
      if (!pts.has(e.pointerId)) return;
      pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (pts.size === 2) {                                    /* pinch */
        const s = Math.min(4, Math.max(1, startScale * dist() / startDist));
        const c = mid(), r = stage.getBoundingClientRect();
        const cx = r.left + r.width / 2, cy = r.top + r.height / 2;
        tx = startTx + (cx - c.x) * (s - startScale) / Math.max(1, startScale);
        ty = startTy + (cy - c.y) * (s - startScale) / Math.max(1, startScale);
        scale = s; apply();
      } else if (pts.size === 1) {
        const dx = e.clientX - sx, dy = e.clientY - sy;
        if (Math.abs(dx) + Math.abs(dy) > 6) moved = true;
        if (scale > 1) { tx = startTx + dx; ty = startTy + dy; apply(); }  /* zoomed: drag pans */
      }
    });
    const up = (e) => {
      if (!pts.has(e.pointerId)) return;
      const dx = e.clientX - sx, dy = e.clientY - sy;
      pts.delete(e.pointerId);
      if (pts.size > 0) { if (scale < 1.05) { scale = 1; tx = 0; ty = 0; apply(); } return; }
      if (scale === 1 && moved) {                              /* fit: swipe navigates / closes */
        if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) { setIndex(idx + (dx < 0 ? 1 : -1)); return; }
        if (dy > 80 && Math.abs(dy) > Math.abs(dx)) { close(); return; }
      }
      if (!moved) {                                             /* tap: maybe double-tap */
        const now = Date.now();
        if (now - lastTap < 320 && Math.hypot(e.clientX - lastTapX, e.clientY - lastTapY) < 40) {
          lastTap = 0;
          if (scale > 1.2) { scale = 1; tx = 0; ty = 0; }
          else {
            const r = stage.getBoundingClientRect();
            const cx = r.left + r.width / 2, cy = r.top + r.height / 2;
            scale = 2.5; tx = (cx - e.clientX) * (2.5 - 1); ty = (cy - e.clientY) * (2.5 - 1);
          }
          apply();
        } else { lastTap = now; lastTapX = e.clientX; lastTapY = e.clientY; }
      }
      if (scale < 1.05) { scale = 1; if (!moved) { tx = 0; ty = 0; } apply(); }
    };
    stage.addEventListener('pointerup', up);
    stage.addEventListener('pointercancel', (e) => pts.delete(e.pointerId));
  };

  const init = () => {
    const m = media(); if (!m) return;
    m.addEventListener('click', (e) => {
      const im = e.target.closest('slideshow-slide img');
      if (!im) return;
      e.preventDefault(); e.stopPropagation();                  /* suppress the theme's zoom dialog */
      const slides = [...m.querySelectorAll('slideshow-slide')];
      const slide = im.closest('slideshow-slide');
      open(Math.max(0, slides.indexOf(slide)));
    }, true);
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
